import React, { useState } from "react";
import styles from "./login.module.scss";
import { IconEye, IconEyeClosed } from "@tabler/icons-react";
import { useAuth } from "../../store/AuthContext";
import { Navigate } from "react-router-dom";
import { useToast } from "../../components/toast";
import api from "../../api";
import logo from "../../assets/images/logo.png";

export default function Login() {
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { isAuthenticated, setAuth } = useAuth();
  const toast = useToast();

  const loginHandler = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const values = {
      email: formData.get("email"),
      password: formData.get("password"),
    };
    // console.log("values --->", values);
    setIsLoading(true);
    const res = await api.login({
      email: values.email,
      password: values.password,
    });
    // console.log("login res --->", res);
    if (res.status === 200) {
      setAuth(res.data.data.access_token);
      toast("Амжилттай нэвтэрлээ", "success");
    } else {
      // console.error("Login error:", res);
      toast(res.data?.message || "Нэвтрэхэд алдаа гарлаа", "error");
    }
    setIsLoading(false);
  };

  if (isAuthenticated) return <Navigate to="/" />;

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <img src={logo} alt="logo" className={styles.logo} />
        <div className={styles.divider}></div>
        <form className={styles.form} onSubmit={loginHandler}>
          <input
            type="email"
            name="email"
            placeholder="И-мэйл"
            className={styles.input}
          />

          <div className={styles.passwordWrapper}>
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              placeholder="Нууц үг"
              className={styles.input}
            />
            <span
              className={styles.eye}
              onClick={() => setShowPassword((prev) => !prev)}
            >
              {showPassword ? <IconEyeClosed /> : <IconEye />}
            </span>
          </div>

          <button type="submit" className={styles.button}>
            Нэвтрэх
          </button>
        </form>
      </div>
    </div>
  );
}
